import { fetchApi } from 'api/index'

export const profileWithDetailsApi = () =>
  fetchApi('/profiles/my?withDetails=true')
